// RoofTable - "On the roof right now": each unit's design values and its
// state at the scrubbed hour. Pending readings (which floor a unit serves,
// read from the energy model's zone names) carry the review badge instead of
// reading as fact. A modelled unit the roof plan does not show says so.
import React from "react";
import { profileAt } from "./glanceModel";

const n = (v) => (v == null ? "" : Number(v).toLocaleString());

// Every unit's source, one entry per document with all its pages: "System Inputs.pdf pp. 43, 53, 63".
export function designSources(equipment) {
  const byDoc = new Map();
  equipment.forEach((e) => (e.source || []).forEach((s) => {
    const name = s.name || s.docId;
    if (!name) return;
    const pages = byDoc.get(name) || byDoc.set(name, new Set()).get(name);
    if (s.page != null) pages.add(Number(s.page));
  }));
  return [...byDoc.entries()].map(([name, pages]) => {
    const list = [...pages].sort((a, b) => a - b);
    return list.length ? `${name} ${list.length > 1 ? "pp." : "p."} ${list.join(", ")}` : name;
  }).join("; ");
}

export default function RoofTable({ manifest, dayType, hour }) {
  const equipment = (manifest.roof && manifest.roof.equipment) || [];
  if (!equipment.length) return null;
  const ops = manifest.operations;
  const bases = [...new Set(equipment.map((e) => e.servesBasis).filter(Boolean))];
  return (
    <>
      <h3>On the roof right now</h3>
      <div className="g-tablewrap">
        <table>
          <thead>
            <tr><th>Unit</th><th>Likely serves</th><th>Cooling</th><th>Supply air</th><th>Outside air</th><th>Status at this hour</th></tr>
          </thead>
          <tbody>
            {equipment.map((e) => {
              const always = e.schedule === "always";
              const on = !!profileAt(ops, e.schedule || "always", dayType, hour);
              const d = e.design || {};
              return (
                <tr key={e.id}>
                  <td>
                    {e.label || e.id}
                    {!e.position && <div className="g-note">Not on the roof plan</div>}
                  </td>
                  <td>
                    {e.servesDetail || e.serves || "Not stated"}
                    {e.review === "pending" && (e.serves || e.servesDetail) && <span className="g-badge" title={`Read from the ${e.servesBasis || "documents"}; confirm against the mechanical sheets`}>Pending</span>}
                  </td>
                  {e.detail && !e.design ? (
                    <td colSpan={3}>{e.detail}</td>
                  ) : (
                    <>
                      <td>{d.coolingMbh ? `${n(d.coolingMbh)} MBH, about ${Math.round(d.coolingMbh / 12)} tons` : ""}</td>
                      <td>{d.supplyCfm ? `${n(d.supplyCfm)} cfm` : ""}</td>
                      <td>{d.outsideAirCfm ? `${n(d.outsideAirCfm)} cfm` : ""}</td>
                    </>
                  )}
                  <td className={on ? "g-on" : "g-offs"}>
                    {always ? "Always on" : on ? "Occupied mode: outside air damper open" : "Setback: outside air damper closed, cooling available on demand"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="g-note" style={{ marginTop: 6 }}>
        Design values from {designSources(equipment) || "the energy model"}.
        {bases.length ? ` "Likely serves" comes from the ${bases.join(", ")}, not from mechanical drawings, so confirm it against the M-sheets.` : ""}
      </p>
    </>
  );
}
